import React, { useLayoutEffect } from 'react'
import { EditorCaret, EditorLine } from 'src/helpers/descriptionEditorCommands'
import { placeCaret, writeEditorDom } from 'src/helpers/descriptionEditorDom'

interface EditorPlacementInput {
  rootRef: React.RefObject<HTMLDivElement | null>
  linesRef: React.MutableRefObject<EditorLine[]>
  caretRef: React.MutableRefObject<EditorCaret | null>
  domVersion: number
  placeholder: string
}

export const useEditorPlacement = ({
  rootRef,
  linesRef,
  caretRef,
  domVersion,
  placeholder
}: EditorPlacementInput): void => {
  useLayoutEffect(() => {
    const root = rootRef.current
    if (root === null) {
      return
    }
    root.setAttribute('aria-placeholder', placeholder)
    writeEditorDom(root, linesRef.current)
    const caret = caretRef.current
    caretRef.current = null
    if (caret === null) {
      return
    }
    const row = root.querySelector<HTMLElement>(`[data-line-id="${CSS.escape(caret.id)}"]`)
    if (row === null) {
      return
    }
    if (row.dataset.lineKind === 'rule') {
      row.focus()
      return
    }
    root.focus()
    placeCaret(row, caret.offset)
  }, [caretRef, domVersion, linesRef, placeholder, rootRef])
}
